import React from 'react';
import classNames from 'classnames';
import './printButton.scss';

export type PrintButtonProps = {
  className?: string;
};

export const PrintButton: React.FC<React.PropsWithChildren<
  PrintButtonProps
>> = ({ children, className }) => (
  <span
    className={classNames('print-button', className, 'no-print')}
    onClick={_ => {
      window && window.print();
    }}
  >
    {children}
  </span>
);
